import { axiosInstance as axios } from "services";

export const addUpdateSeries = async (body) => {
  const isUpdate = body._id || body.id;
  const id = body._id || body.id;
  
  if (isUpdate) {
    const { _id, id: _id2, ...rest } = body;
    const { data } = await axios.patch(`/pricing/master/labor/${id}`, rest);
    if (!data.success) throw new Error(data.error?.message || "Failed to update labor");
    return data;
  } else {
    const { _id, id: _id2, ...rest } = body;
    const { data } = await axios.post("/pricing/master/labor", rest);
    if (!data.success) throw new Error(data.error?.message || "Failed to create labor");
    return data;
  }
};

